module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.73f0a88.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Regular.woff2
// module id = LkR2
// module chunks = 0